import type {HtmlDocType, NodeType} from './node-processors-types';

export const hasHref = (node: HtmlDocType): boolean =>
  node.attribs.href != null;

export const isNotEmpty = (node: HtmlDocType): boolean =>
  node.children.length > 0;

export const isInsidePre = (node: NodeType): boolean =>
  hasParentMatching(node, (parentNode) => parentNode.name === 'pre');

export function hasParentMatching(
  node: NodeType,
  parentChecker: (parentNode: HtmlDocType) => boolean
): boolean {
  let parent = node.parent;

  while (parent != null) {
    if (parentChecker(parent)) {
      return true;
    }

    parent = parent.parent;
  }

  return false;
}
